// extracted by mini-css-extract-plugin
export default {"voice_chat":"VoiceChat_voice_chat__S0ewL","show":"VoiceChat_show__kOPPr","mini_mode":"VoiceChat_mini_mode__5UBBc","meeting":"VoiceChat_meeting__SYtQ8"};